import React from 'react';
import Breadcrumb from 'react-bootstrap/Breadcrumb';

function BreadcrumbMain(props){
    return (
		<>
		<Breadcrumb>
        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
        {props.data.map((b_data, b_index) => (
            <Breadcrumb.Item key={`breadcrumb${b_index}`} href={`/${b_data.link}`}>
                {b_data.title}
            </Breadcrumb.Item>
        ))}
        <Breadcrumb.Item active>{props.title}</Breadcrumb.Item>
        </Breadcrumb>
		</>
    )
}

export {BreadcrumbMain};